import { format } from "date-fns";

export const formatDate = (date?: Date | null, formatString: string = "yyyy-MM-dd HH:mm") => {
  if (!date) {
    return "-";
  }

  return format(date, formatString);
};

export const globalInterval = (() => {
  let callbacks: VoidFunction[] = [];

  setInterval(() => {
    callbacks.forEach((cb) => cb());
  }, 1000);

  return {
    listen: (callback: VoidFunction) => {
      callbacks.push(callback);
      return () => {
        callbacks = callbacks.filter((item) => item !== callback);
      };
    },
  };
})();
